import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AiHelpWidgetComponent } from './ai-help-widget/ai-help-widget.component';
import { AiHelpService } from './ai-help.service';
import { AiHelpVisibilityService } from './ai-help-visibility.service';

/**
 * Módulo isolado do assistente de ajuda com IA — porte do abcx-web
 * (`abcx-web/src/app/shared/ai-help/`) para o Wazir/Core, com estilização
 * própria (tema Wazir). Exporta apenas o widget (FAB + drawer), reutilizável
 * em qualquer shell. Depende só de CommonModule/FormsModule + AuthService do
 * core-web (para os headers de sessão) — sem acoplamento com o CRUD do ERP.
 */
@NgModule({
  declarations: [AiHelpWidgetComponent],
  imports: [CommonModule, FormsModule],
  providers: [AiHelpService, AiHelpVisibilityService],
  exports: [AiHelpWidgetComponent],
})
export class AiHelpModule {}
